import { Phone, Truck, MessageCircle } from "lucide-react";
import { useApp } from "@/context/AppContext";
import { StarBadge } from "@/components/PartnerAlerts";

export const PartnerCard = ({ staff, status, trip }) => {
  const { t } = useApp();
  if (!staff || !["Requested", "Confirmed"].includes(status)) return null;
  return (
    <div className="flex items-center gap-3 rounded-2xl bg-[#2E9E6B]/10 p-4" data-testid="partner-card">
      <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-[#2E9E6B] text-white"><Truck className="h-5 w-5" /></div>
      <div className="min-w-0 flex-1">
        <p className="text-xs font-bold uppercase tracking-wider text-[#2E9E6B]">{t("Your pickup partner")}</p>
        <p className="truncate font-semibold text-[#0D3B2B]" data-testid="partner-name">{staff.name}</p>
        {staff.star && <StarBadge small testid="customer-partner-star" />}
        <p className="text-xs text-[#4A6358]">{staff.mobile}{staff.vehicle ? ` · ${staff.vehicle}` : ""}</p>
        {trip && <span data-testid="partner-trip-status" className={`mt-1 inline-block rounded-full px-2 py-0.5 text-[11px] font-bold text-white ${trip === "Reached" ? "bg-[#2E9E6B]" : "animate-pulse bg-[#E05C3A]"}`}>{t(trip)}</span>}
      </div>
      <div className="flex flex-col gap-2">
        <a href={`tel:+91${staff.mobile}`} onClick={(e) => e.stopPropagation()} data-testid="partner-call-btn"
          className="flex h-10 items-center justify-center gap-1 rounded-full bg-[#0D3B2B] px-4 text-sm font-bold text-white"><Phone className="h-4 w-4" />{t("Call")}</a>
        <a href={`https://wa.me/91${staff.mobile}`} target="_blank" rel="noreferrer" onClick={(e) => e.stopPropagation()} data-testid="partner-whatsapp-btn"
          className="flex h-10 items-center justify-center gap-1 rounded-full bg-[#25D366] px-4 text-sm font-bold text-white"><MessageCircle className="h-4 w-4" />WhatsApp</a>
      </div>
    </div>
  );
};
